export default __webpack_public_path__ + "static/media/trust-wallet.d1b9398f.svg";